export const SET_TAKER = "SET_TAKER";
export const POST_LOGIN = "POST_LOGIN";
export const POST_TOKEN = "POST_TOKEN";
export const SET_TOKEN = "SET_TOKEN";
export const SET_SUBMITTED_COUNT = "SET_SUBMITTED_COUNT";
export const INCREMENT_SUBMITTED_COUNT = "INCREMENT_SUBMITTED_COUNT";
export const POST_LOGIN_IMAGE = "POST_LOGIN_IMAGE";
export const SET_SESSION_ID = "SET_SESSION_ID";
export const SET_2FA_AS_REQUIRED = "SET_2FA_AS_REQUIRED";
